import { computed, get } from '@ember/object';
import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';

export default function computedSanitizeHtml(dependentKey) {
  return computed(dependentKey, function () {
    return sanitizeHtml(get(this, dependentKey));
  });
}
